export const ResourceTypesNamespace = 'resourceTypes'
